import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    epoch: String
  }
  static targets = ["date", "time"]

  connect() {
    const date = new Date(parseFloat(this.epochValue));
    this.dateTarget.innerText = date.toLocaleDateString();
    this.timeTarget.innerText = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  }
}